(function () {
  'use strict';
  function element(tag, className, value) {
    var node = document.createElement(tag);
    node.className = className || '';
    if (value !== undefined) node.textContent = value;
    return node;
  }
  function mount(root) {
    // Every exit below used to be a bare `return`, so a broken window was
    // indistinguishable from a window that had correctly decided not to render.
    // That is the exact failure the thank-you card shipped with. Say why, always.
    function bail(reason) {
      try { console.warn('[kp-bundle-window] not rendering: ' + reason); } catch (error) {}
      root.hidden = true;
      return undefined;
    }
    // bail() is a MOUNT-TIME decision: it hides the window. Never call it from an event
    // handler — a shopper clicking a not-yet-ready button would watch the whole module
    // disappear. Runtime guards use nope(), which says why and changes nothing.
    function nope(reason) {
      try { console.warn('[kp-bundle-window] ignored: ' + reason); } catch (error) {}
      return undefined;
    }
    var config;
    try { config = JSON.parse(root.querySelector('[data-config]').textContent); }
    catch (error) { return bail('config JSON did not parse - check the tiers textarea in theme settings'); }
    var preview = config.preview || (window.Shopify && window.Shopify.designMode);
    var tiers = config.tiers;
    var tier = tiers.filter(function (item) { return item.id === config.preselectedTierId; })[0];
    if (!tier) return bail('preselectedTierId "' + config.preselectedTierId + '" matches no configured tier');
    var flavours = [], slots = [], activeSlot = 0, invokingButton, busy = false;
    var multi = false, draft = [], targets = [];
    var picker = root.querySelector('dialog');
    var status = root.querySelector('[data-status]');
    var add = root.querySelector('[data-add]');
    var selection = root.querySelector('.kp-bundle__selection');
    var chooseAll = element('button', 'kp-bundle__choose', 'Choose remaining flavors');
    chooseAll.type = 'button'; chooseAll.setAttribute('data-choose-all', '');
    selection.appendChild(chooseAll);
    chooseAll.addEventListener('click', function () { openPicker(true, 0, chooseAll); });
    var progress = element('div', 'kp-bundle__progress');
    progress.setAttribute('aria-hidden', 'true');
    selection.insertBefore(progress, selection.querySelector('[data-slots]'));
    function pulse(node, className) {
      node.classList.remove(className);
      void node.offsetWidth;
      node.classList.add(className);
    }
    function track(event, payload) {
      if (!preview && typeof window.kpBundleTrack === 'function') {
        try { window.kpBundleTrack(event, Object.assign({ surface: 'pdp', tier_id: tier.id }, payload || {})); } catch (error) { /* Tracking cannot interrupt shopping. */ }
      }
    }
    function money(amount) { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: config.currency || 'USD' }).format(amount); }
    function size(item) { return item.buyQuantity + item.getQuantity; }
    function price(item) {
      var unit = flavours[0].price;
      return { list: unit * size(item), pay: unit * item.buyQuantity, percent: Math.round(item.getQuantity / size(item) * 100) };
    }
    function render() {
      var container = root.querySelector('[data-tiers]');
      container.textContent = '';
      tiers.forEach(function (item) {
        var row = element('label', 'kp-tier');
        var radio = element('input');
        radio.type = 'radio'; radio.name = 'kp-tier-' + config.hero; radio.value = item.id; radio.checked = item.id === tier.id;
        radio.addEventListener('change', function () {
          tier = item; slots.length = size(tier); render();
          container.querySelector('input:checked').focus();
          pulse(selection, 'kp-bundle__selection--changed'); track('bundle_tier_selected');
        });
        var math = price(item), title = element('span', 'kp-tier__title', item.title);
        title.appendChild(element('span', 'kp-tier__badge', 'SAVE ' + math.percent + '%'));
        title.appendChild(element('small', '', size(item) + ' pouches · ' + size(item) * 2 + ' mini rolls'));
        var prices = element('span', 'kp-tier__prices', money(math.pay));
        prices.appendChild(element('del', '', money(math.list)));
        row.appendChild(radio); row.appendChild(title); row.appendChild(prices); container.appendChild(row);
      });
      var grid = root.querySelector('[data-slots]'); grid.textContent = '';
      for (var i = 0; i < size(tier); i++) {
        (function (index) {
          var flavour = slots[index];
          // Always a <button>, never a <div>. An empty slot used to render as a div with no
          // handler, so the "+ Pick needed" tiles were inert — not clickable, not focusable,
          // not reachable by keyboard — while the button below them did the job. Eddie:
          // "both of these should be clickable and do the same thing."
          var button = element('button', 'kp-slot' + (flavour ? ' kp-slot--filled' : ''));
          button.type = 'button';
          if (flavour) {
            if (flavour.image) { var img = element('img'); img.src = flavour.image; img.alt = ''; img.loading = 'lazy'; button.appendChild(img); }
            button.appendChild(element('span', 'kp-slot__name', flavour.title));
            button.appendChild(element('span', 'kp-slot__tag', index === 0 ? 'YOUR PICK · LOCKED' : 'CHANGE FLAVOR'));
          } else {
            // A pouch outline with a + in it, no caption. The dashed border already says
            // "empty" and the aria-label carries the instruction for screen readers, so the
            // "+ / Pick needed" text was chrome. Icon-only lets the tile shrink.
            var mark = element('span', 'kp-slot__pouch');
            mark.setAttribute('aria-hidden', 'true');
            button.appendChild(mark);
          }
          var remaining = size(tier) - slots.filter(Boolean).length;
          button.setAttribute('aria-label', 'Pouch ' + (index + 1) + ': ' +
            (flavour ? 'change ' + flavour.title : 'choose the ' + remaining + ' remaining flavor' + (remaining === 1 ? '' : 's')));
          if (index === 0) button.disabled = true;
          else button.addEventListener('click', function () {
            // An empty tile opens the SAME multi-select pass as the "Choose remaining
            // flavors" button — one visit fills every empty slot. A filled tile still opens
            // single-slot edit, which is the "I picked wrong" fast path.
            openPicker(!flavour, index, button);
          });
          grid.appendChild(button);
        })(i);
      }
      var filled = slots.filter(Boolean).length;
      chooseAll.textContent = filled === size(tier) ? 'Review your flavors' : 'Choose ' + (size(tier) - filled) + ' remaining flavors';
      root.querySelector('[data-count]').textContent = filled + ' of ' + size(tier) + ' selected';
      progress.style.setProperty('--kp-progress', (filled / size(tier) * 100) + '%');
      add.setAttribute('aria-busy', busy ? 'true' : 'false');
      add.classList.toggle('kp-bundle__add--busy', busy);
      if (filled !== size(tier) || busy) add.classList.remove('kp-bundle__add--ready');
      add.disabled = busy || filled !== size(tier) || preview;
      add.textContent = busy ? 'Adding your flight…' : filled === size(tier) ? 'Add bundle to cart · ' + money(price(tier).pay) : 'Choose ' + (size(tier) - filled) + ' more flavor' + (size(tier) - filled === 1 ? '' : 's');
    }
    function openPicker(all, index, opener) {
      multi = all; activeSlot = index; invokingButton = opener;
      draft = slots.slice(); targets = [];
      for (var i = 1; i < size(tier); i++) { if (!slots[i]) targets.push(i); }
      if (multi && !targets.length) {
        for (var j = 1; j < size(tier); j++) targets.push(j);
      }
      picker.querySelector('[data-search]').value = '';
      picker.querySelector('[data-picker-caption]').textContent = multi ? 'Build your mix. Repeat flavors welcome.' : 'Choosing pouch ' + (index + 1) + ' of ' + size(tier);
      picker.querySelector('[data-picker-confirm]').hidden = !multi;
      renderFlavours('');
      if (typeof picker.showModal === 'function') picker.showModal();
      else { picker.setAttribute('open', ''); picker.classList.add('kp-picker--fallback'); }
      pulse(picker.querySelector('[data-flavours]'), 'kp-picker__grid--enter');
      picker.querySelector('[data-search]').focus();
      track('bundle_picker_opened', { slot_index: index });
    }
    function restoreFocus() {
      if (invokingButton === chooseAll) chooseAll.focus();
      else if (invokingButton) root.querySelector('[data-slots]').children[activeSlot].focus();
    }
    function close() {
      if (typeof picker.close === 'function') picker.close();
      else { picker.removeAttribute('open'); picker.classList.remove('kp-picker--fallback'); }
      restoreFocus();
    }
    function updatePicks() {
      var remaining = targets.filter(function (index) { return !draft[index]; }).length;
      // The remaining-count is the only wayfinding in a grid that scrolls for several
      // screens, so it carries pips as well as a number. Pips are aria-hidden: the live
      // region should announce the sentence, not a row of dots.
      var rem = picker.querySelector('[data-picker-remaining]');
      rem.textContent = '';
      rem.appendChild(element('span', 'kp-picker__remaining-text', multi
        ? (remaining === 0 ? 'All set — confirm your mix' : remaining + ' more flavor' + (remaining === 1 ? '' : 's') + ' to pick')
        : 'Choose 1 flavor'));
      if (multi) {
        var pips = element('span', 'kp-picker__pips');
        pips.setAttribute('aria-hidden', 'true');
        for (var t = 0; t < targets.length; t++) {
          pips.appendChild(element('span', 'kp-picker__pip' + (draft[targets[t]] ? ' is-filled' : '')));
        }
        rem.appendChild(pips);
      }
      if (multi && remaining === 0) rem.className = 'is-complete'; else rem.className = '';
      picker.querySelector('[data-picker-confirm]').disabled = remaining !== 0;
      Array.prototype.forEach.call(picker.querySelectorAll('.kp-flavour'), function (card) {
        var id = card.getAttribute('data-variant');
        var count = targets.filter(function (index) { return draft[index] && String(draft[index].id) === id; }).length;
        card.querySelector('[data-pick]').disabled = multi && remaining === 0;
        var badge = card.querySelector('[data-picked-count]'), remove = card.querySelector('[data-unpick]');
        if (badge) { badge.textContent = count + ' selected'; badge.hidden = count === 0; }
        if (remove) remove.disabled = count === 0;
      });
    }
    picker.querySelector('[data-picker-confirm]').addEventListener('click', function () {
      if (!multi || targets.some(function (index) { return !draft[index]; })) return nope('picker confirmation requires every remaining pouch');
      slots = draft.slice(); render(); close();
      targets.forEach(function (index) { pulse(root.querySelector('[data-slots]').children[index], 'kp-slot--picked'); });
      pulse(add, 'kp-bundle__add--ready');
      status.textContent = 'Your mix is ready. Add your flight when you’re ready.';
    });
    function renderFlavours(search) {
      var grid = picker.querySelector('[data-flavours]'); grid.classList.remove('kp-picker__grid--enter'); grid.textContent = '';
      flavours.filter(function (flavour) { return flavour.title.toLowerCase().indexOf(search.toLowerCase()) !== -1; }).forEach(function (flavour) {
        var card = element('article', 'kp-flavour');
        card.setAttribute('data-variant', flavour.id);
        card.style.setProperty('--kp-card-delay', Math.min(grid.children.length, 7) * 20 + 'ms');
        if (flavour.image) { var img = element('img'); img.src = flavour.image; img.alt = flavour.title + ' pouch'; img.loading = 'lazy'; card.appendChild(img); }
        card.appendChild(element('h3', '', flavour.title)); card.appendChild(element('p', '', '2 mini rolls · ' + money(flavour.price)));
        var choose = element('button', '', multi ? 'Add' : 'Choose'); choose.type = 'button'; choose.setAttribute('data-pick', ''); choose.setAttribute('aria-label', (multi ? 'Add ' : 'Choose ') + flavour.title);
        choose.addEventListener('click', function () {
          if (multi) {
            var next = targets.filter(function (index) { return !draft[index]; })[0];
            if (next === undefined) return nope('all remaining pouches are already selected');
            draft[next] = flavour; track('bundle_slot_filled', { slot_index: next, variant_id: flavour.id });
            updatePicks();
            if (choose.disabled) picker.querySelector('[data-picker-confirm]').focus();
          } else {
            var wasComplete = slots.filter(Boolean).length === size(tier);
            slots[activeSlot] = flavour; track('bundle_slot_filled', { slot_index: activeSlot, variant_id: flavour.id });
            render(); close();
            var selected = root.querySelector('[data-slots]').children[activeSlot];
            selected.focus(); pulse(selected, 'kp-slot--picked');
            pulse(root.querySelector('[data-count]'), 'kp-bundle__count--changed');
            if (!wasComplete && slots.filter(Boolean).length === size(tier)) {
              pulse(add, 'kp-bundle__add--ready');
              status.textContent = 'Your mix is ready. Add your flight when you’re ready.';
            }
          }
        });
        card.appendChild(choose);
        if (multi) {
          var badge = element('span', 'kp-flavour__count'); badge.setAttribute('data-picked-count', ''); card.appendChild(badge);
          var remove = element('button', 'kp-flavour__remove', 'Remove one');
          remove.type = 'button'; remove.setAttribute('data-unpick', ''); remove.setAttribute('aria-label', 'Remove one ' + flavour.title);
          remove.addEventListener('click', function () {
            var picked = targets.filter(function (index) { return draft[index] && draft[index].id === flavour.id; });
            if (!picked.length) return nope('no selected pouch of ' + flavour.title + ' to remove');
            var index = picked[picked.length - 1]; draft[index] = null;
            track('bundle_slot_cleared', { slot_index: index, variant_id: flavour.id }); updatePicks();
            if (remove.disabled) choose.focus();
          });
          card.appendChild(remove);
        }
        grid.appendChild(card);
      });
      picker.querySelector('[data-empty]').hidden = !!grid.children.length;
      updatePicks();
    }
    picker.querySelector('[data-search]').addEventListener('input', function (event) { renderFlavours(event.target.value); });
    picker.querySelector('[data-close]').addEventListener('click', close);
    picker.addEventListener('close', restoreFocus);
    picker.addEventListener('cancel', function (event) { event.preventDefault(); close(); });
    picker.addEventListener('keydown', function (event) {
      if (event.key === 'Tab') {
        var controls = Array.prototype.filter.call(picker.querySelectorAll('button, input, [tabindex]'), function (node) { return !node.disabled && node.tabIndex >= 0 && node.getClientRects().length; });
        var first = controls[0], last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
      if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); close(); }
    });
    document.addEventListener('focusin', function (event) {
      if (picker.hasAttribute('open') && !picker.contains(event.target)) picker.querySelector('[data-search]').focus();
    });
    picker.addEventListener('click', function (event) { if (event.target === picker) close(); });
    add.addEventListener('click', function () {
      if (add.disabled) return nope('bundle is not ready to add');
      busy = true; render(); status.textContent = ''; track('bundle_add_clicked', { variant_ids: slots.map(function (slot) { return slot.id; }) });
      var route = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(route + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: slots.map(function (slot) { return { id: slot.id, quantity: 1 }; }), sections: ['cart-drawer', 'cart-icon-bubble'] }) }).then(function (response) {
        return response.json().then(function (data) { if (!response.ok) throw new Error(data.description || data.message || 'Unable to add this bundle.'); return data; });
      }).then(function (data) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(data);
        return fetch(route + 'cart.js').then(function (response) { if (!response.ok) throw new Error('Bundle added, but cart total could not be loaded. Open your cart to check.'); return response.json(); });
      }).then(function (cart) {
        var subtotal = cart.total_price / 100, summary = root.querySelector('[data-cart]'); config.currency = cart.currency;
        var discounted = cart.items.some(function (line) { return line.line_level_discount_allocations && line.line_level_discount_allocations.length; });
        summary.textContent = 'Your cart: ' + money(subtotal);
        var threshold = Number(config.shippingThreshold);
        if (threshold > 0) {
          summary.appendChild(element('div', '', subtotal >= threshold ? 'You’ve reached the free shipping threshold.' : money(threshold - subtotal) + ' away from free shipping.'));
          var progress = element('progress'); progress.max = threshold; progress.value = Math.min(subtotal, threshold); progress.setAttribute('aria-label', 'Progress toward free shipping'); summary.appendChild(progress);
        }
        summary.hidden = false;
        pulse(summary, 'kp-bundle__cart--confirmed');
        status.textContent = discounted ? 'Your flavor flight is in your cart.' : 'Pouches added. The expected discount was not confirmed. Check your cart before checkout.';
        track('bundle_cart_confirmed', { subtotal: subtotal, discount_applied: discounted, variant_ids: slots.map(function (slot) { return slot.id; }) });
      }).catch(function (error) { status.textContent = error.message; }).then(function () { busy = false; render(); });
    });
    function ready(items) {
      flavours = items;
      // Uniform price, not a hard-coded 3. Shopify's Buy X Get Y discounts the CHEAPEST
      // eligible item, so a mixed-price collection makes the SAVE badge lie. Comparing
      // against flavours[0] keeps that guard honest through a price change; comparing
      // against the literal 3 would silently delete the window the day a pouch moves off $3.00.
      if (flavours.length < Math.max.apply(null, tiers.map(size))) return bail('only ' + flavours.length + ' eligible flavours in stock, largest tier needs ' + Math.max.apply(null, tiers.map(size)));
      if (flavours.some(function (item) { return item.price !== flavours[0].price || item.currency !== flavours[0].currency; })) return bail('collection ' + config.collectionHandle + ' holds mixed prices - the SAVE badge would be wrong');
      slots[0] = flavours.filter(function (item) { return String(item.id) === String(config.hero); })[0];
      if (!slots[0]) return bail('the variant on this page is not in ' + config.collectionHandle);
    // ---- placement -------------------------------------------------------
    // The section renders full width at the bottom of the template, which is not
    // where a buy-box offer belongs. Relocate into the product column, directly
    // under the PRICE, then keep it there. (It used to go under the add-to-cart
    // form -- see the note below for why that moved.)
    //
    // This copies sections/kp-subscribe.liquid, which solved the same problem on
    // this theme and carries the scar tissue: the theme re-renders <product-info>
    // after load AND on every variant change, which destroys anything we injected
    // into it. So we re-place whenever the node is disconnected, watch the buy box
    // for mutations, and take a few late passes for slow renders.
    var placed = false;
    // UNDER THE PRICE. Changed 2026-09-21.
    //
    // This used to anchor above the add-to-cart, on the reasoning that a Buy-X-Get-Y
    // offer changes WHAT the shopper is adding so it must be read before the CTA.
    // Sound reasoning, wrong result. Measured on a live 2 Mini flavour PDP: the buy
    // block on this theme sits below a 1,816px description section, so the module
    // landed at y=1050 -- 0.84 screens down, behind the short description, the
    // "What's Included" list and the "Pick your Flavor" row -- and pushed ADD TO CART
    // to y=1877, 1.51 screens.
    //
    //   228 title   264 price   358 description   586 flavour row   1050 <- module
    //
    // Three days live produced exactly one use of the discount (order SP_61559).
    // An offer a shopper must scroll past the description to find is not an offer.
    // Anchored to the price it lands at y=303, 0.25 screens. ADD TO CART does not
    // move: the module changes position within the column, not the column's height.
    //
    // Side benefit: .price-wrapper sits OUTSIDE <product-info>, and it was
    // product-info's re-render on every variant change that kept destroying the
    // injected node. The watcher below stays regardless -- this theme has surprised
    // us before and an observer is cheap.
    //
    // Verified 2026-09-21: .single-product .price-wrapper is present exactly once on
    // all 16 eligible 2 Mini flavour PDPs, every one of which uses the default
    // product template.
    //
    // Returns the node AND the side to insert on, because the price anchor wants
    // afterend while the add-to-cart fallback wants beforebegin. Letting those two
    // drift apart silently puts the module on the wrong side of the CTA, so they
    // travel together.
    function anchorEl() {
      var price = document.querySelector('.single-product .price-wrapper')
               || document.querySelector('.kingpalm_product_summary .price-wrapper')
               || document.querySelector('.single-product .kingpalm_product_summary');
      if (price && price.parentNode) return { el: price, where: 'afterend' };
      // Fallback: the old anchor. Still correct, just lower. Covers any template that
      // does not carry the KP summary markup.
      var form = document.querySelector('.single-product product-form')
              || document.querySelector('.single-product .product-form__buttons')
              || document.querySelector('product-form');
      return form && form.parentNode ? { el: form, where: 'beforebegin' } : null;
    }
    function place() {
      var a = anchorEl();
      if (!a) return false;
      var already = a.where === 'afterend'
        ? root.previousElementSibling === a.el
        : root.nextElementSibling === a.el;
      if (root.isConnected && already) return true;
      a.el.insertAdjacentElement(a.where, root);
      placed = true;
      return true;
    }
    function watchPlacement() {
      var host = document.querySelector('.single-product .summary.entry-summary')
              || document.querySelector('.single-product');
      if (host && window.MutationObserver) {
        var t;
        new MutationObserver(function () {
          clearTimeout(t);
          t = setTimeout(place, 80);
        }).observe(host, { childList: true, subtree: true });
      }
      [600, 1500, 3000, 6000].forEach(function (ms) { setTimeout(place, ms); });
    }

      config.currency = flavours[0].currency; slots.length = size(tier);
      place(); watchPlacement();
      root.hidden = false; render(); track('bundle_rendered');
      if (!preview && window.IntersectionObserver) {
        var timer, observer = new IntersectionObserver(function (entries) {
          clearTimeout(timer);
          if (entries[0].intersectionRatio >= 0.5) timer = setTimeout(function () { track('bundle_impression'); observer.disconnect(); }, 1000);
        }, { threshold: [0, 0.5] }); observer.observe(root);
      }
    }
    if (preview) {
      ready(Array.from({ length: 12 }, function (_, i) { return { id: i ? i : config.hero, title: i ? 'Flavor ' + (i + 1) : 'Your current flavor', price: 3, currency: 'USD' }; }));
      status.textContent = 'Theme editor preview. Cart actions and tracking are disabled.'; return;
    }
    // Liquid renders the eligible flavours into the page. Preferred: no extra request,
    // no token, and the list cannot disagree with the collection. The Storefront API
    // path below stays as a fallback for contexts where Liquid cannot see the collection.
    var inline = root.querySelector('[data-flavours]');
    if (inline) {
      var listed;
      try { listed = JSON.parse(inline.textContent); }
      catch (error) { return bail('the Liquid-rendered flavour list did not parse'); }
      if (!listed.length) return bail('collection ' + config.collectionHandle + ' is empty or not published to the Online Store');
      return ready(listed.filter(function (item) { return item.available; }).map(function (item) {
        return { id: String(item.id), title: item.title, price: Number(item.price), currency: item.currency, image: item.image || '' };
      }));
    }
    if (!config.token) return bail('no Storefront API token set in theme settings');
    var query = 'query($handle:String!,$after:String){collection(handle:$handle){products(first:100,after:$after,sortKey:BEST_SELLING){pageInfo{hasNextPage endCursor}nodes{title featuredImage{url}variants(first:100){nodes{id availableForSale price{amount currencyCode}image{url}}}}}}}';
    function load(after, accumulated) {
      return fetch('/api/2026-07/graphql.json', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': config.token }, body: JSON.stringify({ query: query, variables: { handle: config.collectionHandle, after: after } }) }).then(function (response) { if (!response.ok) throw new Error('Catalog unavailable'); return response.json(); }).then(function (data) {
        var products = data.data && data.data.collection && data.data.collection.products;
        if (!products) throw new Error('Eligible collection unavailable');
        products.nodes.forEach(function (product) { product.variants.nodes.forEach(function (variant) {
          if (variant.availableForSale) accumulated.push({ id: variant.id.split('/').pop(), title: product.title.replace(/^2 Mini Rolls\s*-\s*/, ''), price: Number(variant.price.amount), currency: variant.price.currencyCode, image: (variant.image || product.featuredImage || {}).url });
        }); });
        return products.pageInfo.hasNextPage ? load(products.pageInfo.endCursor, accumulated) : accumulated;
      });
    }
    load(null, []).then(ready).catch(function (error) { bail('catalog fetch failed: ' + error.message); });
  }
  function start() { Array.prototype.forEach.call(document.querySelectorAll('[data-kp-bundle]'), mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
